import { useMemo } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import PropTypes from "prop-types";

import { routePaths } from "../../../consts";

import { BreadcrumbContainer } from "../styled";
import { dispatch } from "../../../state/store";
import {
  resetConsentElements,
  setBreadcrumbsRedirectUrl,
  setIsDuplicate,
  setIsViewOnly,
  setSelectedConsent
} from "../../../state/ducks";
import { LinkStyled } from "../../NavLink/styled";

const AppBreadcrumb = ({ slashBefore = false, slashAfter = false, onClick, isSameConsentData }) => {
  const { appName } = useParams();

  const history = useHistory();

  const isDisable = useMemo(() => {
    return (
      !isSameConsentData &&
      (history.location.pathname.includes(routePaths.CONSENT_ELEMENT_CREATE) ||
        history.location.pathname.includes(routePaths.CONSENT_ELEMENT_EDIT))
    );
  }, []);

  const resetConsentsData = () => {
    dispatch(setSelectedConsent(null));
    dispatch(resetConsentElements());
    dispatch(setIsDuplicate(false));
    dispatch(setIsViewOnly(false));
  };

  return (
    <LinkStyled
      as={isSameConsentData ? Link : "button"}
      to={routePaths.CREATE_APP}
      onClick={() => {
        if (isSameConsentData) {
          resetConsentsData();
        } else {
          dispatch(setBreadcrumbsRedirectUrl(routePaths.CREATE_APP));
          onClick && onClick();
        }
      }}
      disabled={isDisable}>
      <BreadcrumbContainer slashBefore={slashBefore} slashAfter={slashAfter}>
        {appName}
      </BreadcrumbContainer>
    </LinkStyled>
  );
};

AppBreadcrumb.propTypes = {
  slashBefore: PropTypes.bool,
  slashAfter: PropTypes.bool,
  isSameConsentData: PropTypes.bool,
  onClick: PropTypes.func
};

export default AppBreadcrumb;
